import { Platform } from 'react-native';
import DeviceInfo from 'react-native-device-info';

// TODO: I don`t like this implementation. We should find a way to get baseOS without await and just make everything into a const here.

const MB_deviceInfoInitialize = async () => {
  const baseOS = await DeviceInfo.getBaseOs();

  MB_deviceInfoisInitialized = true;
  // isMobile also detects mobile browsers.
  isMobile = Platform.OS === 'android' || Platform.OS === 'ios' || baseOS === 'Android' || baseOS === 'iOS';
  isMobileApp = Platform.OS !== 'web';
  // TODO: Replace with expo-devicee once they fix their emulator detection issues.
  isEmulator = isMobileApp && (await DeviceInfo.isEmulator());
};

/**
 * Indicates wether all the data is initialized.
 * Check once in the root of the application. If returns false, call `await MB_deviceInfoInitialize()`.
 */
let MB_deviceInfoisInitialized = false;

/**
 * True for mobile applications and for mobile browsers
 */
let isMobile = Platform.OS !== 'web';

/**
 * True for mobile applications (false for browsers)
 */
let isMobileApp = Platform.OS !== 'web';

let isTablet = DeviceInfo.isTablet();

/**
 * True if running on emulators.
 */
let isEmulator = true;

const MB_deviceInfo = {
  getInstallerPackageName: DeviceInfo.getInstallerPackageNameSync(),
};

export { MB_deviceInfo, MB_deviceInfoInitialize, MB_deviceInfoisInitialized, isMobile, isMobileApp, isEmulator, isTablet };
